var map = {
	"./suite1.png": "9e41",
	"./suite10.png": "94d0",
	"./suite11.png": "b067",
	"./suite12.png": "96ff",
	"./suite13.png": "1e8b",
	"./suite14.png": "e5bf",
	"./suite2.png": "f91e",
	"./suite3.png": "4657",
	"./suite4.png": "01ca",
	"./suite5.png": "263a",
	"./suite6.png": "4acc",
	"./suite7.png": "eea8",
	"./suite8.png": "ddf9",
	"./suite9.png": "7a2f",
	"./suitebg.png": "9acb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e176";